<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright float-right">
        © {{ currentYear }} por
        <a href="https://www.grupodiginet.com.br" target="_blank"
          >Grupo Diginet</a
        >.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  computed: {
    currentYear: {
      set(_currentYear) {},
      get() {
        let date = new Date();
        return date.getFullYear();
      },
    },
  },
};
</script>

<style scoped>
.footer {
  z-index: 3;
}
</style>